import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import { LessonComponent } from './lesson_component';
export const CourseDayLessons = ({ dayLesson, isVertical, isMin, apiClient, classObject, onClick, }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(LessonComponent, { lesson: dayLesson.lesson, courseDayLessonID: dayLesson.id, addFavoriteLesson: apiClient.addFavoriteLesson, unFavoriteLesson: apiClient.unFavoriteLesson, isMin: isMin, isVertical: isVertical, onClick: onClick })));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        width: '100%',
        [MediaBreakPointUp.MD]: {
            gap: 20,
        },
    },
});
